<!-- Discard Changes Confirmation Modal -->
<div class="modal-overlay" *ngIf="showDiscardConfirmModal" (click)="cancelDiscardChanges()">
    <div class="modal-dialog discard-confirm-modal" (click)="$event.stopPropagation()">
        <div class="modal-content discard-modal-content">
            <div class="modal-header discard-modal-header">
                <h2 class="modal-title">
                    <fa-icon [icon]="icons.faExclamationTriangle" class="warning-icon"></fa-icon>
                    Discard Changes
                </h2>
                <button type="button" class="modal-close" (click)="cancelDiscardChanges()" aria-label="Close">
                    <fa-icon [icon]="icons.faTimes"></fa-icon>
                </button>
            </div>

            <div class="modal-body discard-modal-body">
                <p class="discard-confirmation-text">
                    Are you sure you want to discard all unsaved changes?
                </p>
                <p class="discard-warning-text">
                    This action cannot be undone. All modifications will be reverted to their last saved state.
                </p>
            </div>

            <div class="modal-footer discard-modal-footer">
                <button type="button" class="btn-cancel-discard" (click)="cancelDiscardChanges()">
                    <fa-icon [icon]="icons.faTimes"></fa-icon>
                    Keep Changes
                </button>
                <button type="button" class="btn-confirm-discard" (click)="confirmDiscardChanges()">
                    <fa-icon [icon]="icons.faUndo"></fa-icon>
                    Discard All Changes
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Delete User Confirmation Modal -->
<div class="modal fade" id="modal_delete_user" tabindex="-1" role="dialog" aria-labelledby="modalKeepSpotLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content delete-modal-content">
            <div class="modal-header delete-modal-header">
                <h5 class="modal-title" id="modalKeepSpotLabel">
                    <fa-icon [icon]="icons.faExclamationTriangle" class="warning-icon"></fa-icon>
                    Delete User Confirmation
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body delete-modal-body">
                <p class="delete-confirmation-text">You are about to delete:</p>
                <div class="user-info-card">
                    <p class="user-name">{{ modal_user?.name }}</p>
                    <p class="user-email">{{ modal_user?.email }}</p>
                </div>
                <p class="delete-warning">This action cannot be undone. Are you sure?</p>
                <div *ngIf="modal_error" class="alert alert-danger delete-error" role="alert">
                    <fa-icon [icon]="icons.faExclamationCircle"></fa-icon>
                    {{ modal_error }}
                </div>
            </div>
            <div class="modal-footer delete-modal-footer">
                <button type="button" class="btn btn-secondary cancel-btn" data-dismiss="modal"
                    (click)="modal_error=undefined;">Cancel</button>
                <button type="button" class="btn btn-danger delete-btn" (click)="removeUser(modal_user); modal_user = undefined; ">
                    <fa-icon [icon]="icons.faTrashCan"></fa-icon>
                    Delete User
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Authorized View -->
<div *ngIf="boardPermissions.userHasEditPermissions(boardPermissions.boardUser)" class="admin-users-container">
    <!-- Header -->
    <div class="users-header">
        <div class="header-content">
            <div class="header-top">
                <div class="header-title-section">
                    <h1 class="users-title">
                        <fa-icon [icon]="icons.faUsers" class="title-icon"></fa-icon>
                        User Management
                    </h1>
                    <p class="users-subtitle">Manage user roles and permissions</p>
                </div>
                <div class="header-actions" *ngIf="boardPermissions.userHasAdminPermissions(boardPermissions.boardUser)">
                    <button type="button" class="btn-save-changes" 
                            [disabled]="!hasUnsavedChanges || isSaving"
                            [class.has-unsaved]="hasUnsavedChanges"
                            (click)="saveAllChanges()"
                            title="Save all changes to the database">
                        <fa-icon [icon]="icons.faSave" *ngIf="!isSaving"></fa-icon>
                        <span class="spinner" *ngIf="isSaving">
                            <fa-icon [icon]="icons.faSpinner"></fa-icon>
                        </span>
                        {{ isSaving ? 'Saving...' : 'Save Changes' }}
                    </button>
                    <button type="button" class="btn-discard-changes" 
                            [disabled]="!hasUnsavedChanges"
                            (click)="discardChanges()"
                            title="Discard all unsaved changes">
                        <fa-icon [icon]="icons.faUndo"></fa-icon>
                        Discard
                    </button>
                </div>
            </div>
            <div class="unsaved-indicator" *ngIf="hasUnsavedChanges && boardPermissions.userHasAdminPermissions(boardPermissions.boardUser)">
                <fa-icon [icon]="icons.faExclamationCircle"></fa-icon>
                You have unsaved changes
            </div>
        </div>
    </div>

    <!-- Users Table Card -->
    <div class="users-card">
        <div class="card-body-table">
            <div class="table-responsive">
                <table class="users-table">
                    <thead class="table-header">
                        <tr>
                            <th class="action-column">Actions</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Cell Phone #</th>
                            <th class="role-column">Walk-in Eligible</th>
                            <th class="eligibility-column" *ngIf="boardConfig?.enablePhoneChannel">Phone Eligible</th>
                            <th class="eligibility-column" *ngIf="boardConfig?.enableOnlineChannel">Internet Eligible</th>
                            <th class="role-column">Board Manager</th>
                            <th class="role-column">Admin</th>
                        </tr>
                    </thead>
                    <tbody class="table-body">
                        <!-- Existing Users -->
                        <tr *ngFor="let user of sort(users)" class="user-row" [class.modified]="hasUnsavedChanges && originalUsers.get(user.email) && !isUserDataEqual(originalUsers.get(user.email)!, user)">
                            <td class="action-cell">
                                <div class="action-buttons" *ngIf="boardPermissions.userHasAdminPermissions(boardPermissions.boardUser)">
                                    <button type="button" class="btn-icon delete-btn-icon" title="Delete User" 
                                            (click)="modal_user = user"
                                            data-toggle="modal" data-target="#modal_delete_user">
                                        <fa-icon [icon]="icons.faTrashCan"></fa-icon>
                                    </button>
                                </div>
                            </td>
                            <td class="name-cell">
                                <div *ngIf="boardPermissions.userHasAdminPermissions(boardPermissions.boardUser)" class="editable-field">
                                    <input type="text" class="input-field" [(ngModel)]="user.name" (change)="onUserChange()">
                                </div>
                                <div *ngIf="!boardPermissions.userHasAdminPermissions(boardPermissions.boardUser)" class="static-field">
                                    {{ user.name }}
                                </div>
                            </td>
                            <td class="email-cell">{{ user.email }}</td>
                            <td class="phone-cell">
                                <div *ngIf="boardPermissions.userHasAdminPermissions(boardPermissions.boardUser)" class="editable-field">
                                    <input type="tel" class="input-field" [(ngModel)]="user.phone" (change)="onUserChange()">
                                </div>
                                <div *ngIf="!boardPermissions.userHasAdminPermissions(boardPermissions.boardUser)" class="static-field">
                                    {{ user.phone }}
                                </div>
                            </td>
                            <!-- Walk-in Eligible (salesman role) -->
                            <td class="role-cell">
                                <div class="role-checkbox">
                                    <input type="checkbox" [checked]="user.roles.salesman"
                                        [disabled]="!boardPermissions.userHasAdminPermissions(boardPermissions.boardUser)"
                                        (change)="user.roles.salesman=!user.roles.salesman; onUserChange()">
                                </div>
                            </td>
                            <!-- Phone Channel Eligibility -->
                            <td class="eligibility-cell" *ngIf="boardConfig?.enablePhoneChannel">
                                <div class="eligibility-checkbox">
                                    <input type="checkbox" 
                                        [checked]="isChannelEligible(user, 'phone')"
                                        [disabled]="!boardPermissions.userHasAdminPermissions(boardPermissions.boardUser)"
                                        (change)="toggleEligibilityDirect(user, 'phone', $event)"
                                        title="Toggle phone channel eligibility">
                                </div>
                            </td>
                            <!-- Internet Channel Eligibility -->
                            <td class="eligibility-cell" *ngIf="boardConfig?.enableOnlineChannel">
                                <div class="eligibility-checkbox">
                                    <input type="checkbox" 
                                        [checked]="isChannelEligible(user, 'online')"
                                        [disabled]="!boardPermissions.userHasAdminPermissions(boardPermissions.boardUser)"
                                        (change)="toggleEligibilityDirect(user, 'online', $event)"
                                        title="Toggle internet channel eligibility">
                                </div>
                            </td>
                            <!-- Board Manager -->
                            <td class="role-cell">
                                <div class="role-checkbox">
                                    <input type="checkbox" [checked]="user.roles.board_manager"
                                        [disabled]="!boardPermissions.userHasAdminPermissions(boardPermissions.boardUser)"
                                        (change)="user.roles.board_manager=!user.roles.board_manager; onUserChange()">
                                </div>
                            </td>
                            <!-- Admin -->
                            <td class="role-cell">
                                <div class="role-checkbox">
                                    <input type="checkbox" [checked]="user.roles.admin"
                                        [disabled]="!boardPermissions.userHasAdminPermissions(boardPermissions.boardUser)"
                                        (change)="user.roles.admin=!user.roles.admin; onUserChange()">
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Add New User Button -->
        <div class="table-footer">
            <button type="button" class="btn-add-user" (click)="openAddUserModal()" 
                    *ngIf="boardPermissions.userHasEditPermissions(boardPermissions.boardUser)">
                <fa-icon [icon]="icons.faUserPlus"></fa-icon>
                {{ boardPermissions.userHasAdminPermissions(boardPermissions.boardUser) ? 'Add New User' : 'Request New Salesman' }}
            </button>
        </div>
    </div>

    <!-- Add User Modal Dialog -->
    <div class="modal-overlay" *ngIf="showAddUserModal" (click)="closeAddUserModal()">
        <div class="modal-dialog" (click)="$event.stopPropagation()">
            <div class="modal-content add-user-modal">
                <div class="modal-header add-user-header">
                    <h2 class="modal-title">
                        <fa-icon [icon]="boardPermissions.userHasAdminPermissions(boardPermissions.boardUser) ? icons.faUserPlus : icons.faBriefcase"></fa-icon>
                        {{ boardPermissions.userHasAdminPermissions(boardPermissions.boardUser) ? 'Add New User' : 'Request New Salesman' }}
                    </h2>
                    <button type="button" class="modal-close" (click)="closeAddUserModal()" aria-label="Close">
                        <fa-icon [icon]="icons.faTimes"></fa-icon>
                    </button>
                </div>

                <div class="modal-body add-user-body">
                    <div class="form-group">
                        <label for="newUserName" class="form-label">Full Name *</label>
                        <input type="text" id="newUserName" class="form-input" 
                               [(ngModel)]="new_user.data.name" 
                               placeholder="Enter user's full name"
                               (keyup.enter)="boardPermissions.userHasAdminPermissions(boardPermissions.boardUser) ? submitAddUser() : submitAddSalesman()">
                    </div>

                    <div class="form-group">
                        <label for="newUserEmail" class="form-label">Email Address *</label>
                        <input type="email" id="newUserEmail" class="form-input" 
                               [(ngModel)]="new_user.email" 
                               placeholder="Enter email address"
                               (keyup.enter)="boardPermissions.userHasAdminPermissions(boardPermissions.boardUser) ? submitAddUser() : submitAddSalesman()">
                    </div>

                    <div class="form-group">
                        <label for="newUserPhone" class="form-label">Phone Number</label>
                        <input type="tel" id="newUserPhone" class="form-input" 
                               [(ngModel)]="new_user.data.phone" 
                               placeholder="Enter phone number"
                               (keyup.enter)="boardPermissions.userHasAdminPermissions(boardPermissions.boardUser) ? submitAddUser() : submitAddSalesman()">
                    </div>

                    <!-- Role Selection (Admin Only) -->
                    <div *ngIf="boardPermissions.userHasAdminPermissions(boardPermissions.boardUser)" class="roles-section">
                        <label class="form-label">User Roles</label>
                        <div class="role-option">
                            <input type="checkbox" id="newUserAdmin" [checked]="new_user.data.roles.admin"
                                   (change)="new_user.data.roles.admin=!new_user.data.roles.admin">
                            <label for="newUserAdmin" class="role-label">Administrator</label>
                            <span class="role-description">Full access to all features and settings</span>
                        </div>
                        <div class="role-option">
                            <input type="checkbox" id="newUserManager" [checked]="new_user.data.roles.board_manager"
                                   (change)="new_user.data.roles.board_manager=!new_user.data.roles.board_manager">
                            <label for="newUserManager" class="role-label">Board Manager</label>
                            <span class="role-description">Can manage board settings and users</span>
                        </div>
                        <div class="role-option">
                            <input type="checkbox" id="newUserSalesman" [checked]="new_user.data.roles.salesman"
                                   (change)="new_user.data.roles.salesman=!new_user.data.roles.salesman">
                            <label for="newUserSalesman" class="role-label">Salesman</label>
                            <span class="role-description">Can manage deliveries and sales data</span>
                        </div>
                    </div>

                    <!-- Error Message -->
                    <div *ngIf="modal_add_error" class="error-message">
                        <fa-icon [icon]="icons.faExclamationCircle"></fa-icon>
                        {{ modal_add_error }}
                    </div>
                </div>

                <div class="modal-footer add-user-footer">
                    <button type="button" class="btn-cancel" (click)="closeAddUserModal()">
                        Cancel
                    </button>
                    <button type="button" class="btn-submit" 
                            [disabled]="!new_user.email || !new_user.data.name"
                            (click)="boardPermissions.userHasAdminPermissions(boardPermissions.boardUser) ? submitAddUser() : submitAddSalesman()">
                        <fa-icon [icon]="icons.faCheck"></fa-icon>
                        {{ boardPermissions.userHasAdminPermissions(boardPermissions.boardUser) ? 'Add User' : 'Submit Request' }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Footer Note -->
    <div class="users-footer" *ngIf="!boardPermissions.userHasAdminPermissions(boardPermissions.boardUser)">
        <p>
            <fa-icon [icon]="icons.faInfoCircle"></fa-icon>
            You can request a new salesman, but changes to existing users require administrator privileges.
        </p>
    </div>
</div>

<!-- Unauthorized View -->
<div *ngIf="!boardPermissions.userHasEditPermissions(boardPermissions.boardUser)" class="unauthorized-container">
    <div class="unauthorized-card">
        <div class="unauthorized-icon">
            <fa-icon [icon]="icons.faLock"></fa-icon>
        </div>
        <h1 class="unauthorized-title">403 - Access Denied</h1>
        <p class="unauthorized-message">You are not authorized to view or manage users.</p>
        <p class="unauthorized-detail">Please contact an administrator if you believe this is an error.</p>
    </div>
</div>
